import { useState } from 'react'

import { DATE_INPUT_FORMAT_HINT, DatePicker } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { boolean, controls, dateTime, text } from '../Controls'

import { DateTimeProviderProps } from './DateTimeProviderProps'

export function DatePickerUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('clearable', true))
      .add(boolean('disabled', false))
      .add(text('formatHint', DATE_INPUT_FORMAT_HINT))
      .add(text('label', 'Date picker'))
      .add(dateTime('maxValue', null))
      .add(dateTime('minValue', null))
      .add(text('placeholder', 'Select date'))
      .add(dateTime('value', null))
  )

  function handleChange(nextValue) {
    setProps(currProps => currProps.setValue('value', nextValue))
  }

  return (
    <DateTimeProviderProps>
      <Component
        {...props.getValues()}
        Component={DatePicker}
        name='DatePicker'
        onChange={handleChange}
      />
      <ComponentProps name='DatePicker' value={props} onChange={setProps} />
    </DateTimeProviderProps>
  )
}
